import { Button, Modal } from "react-bootstrap";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  id: string;
  name: string;
  onDelete: (id: string) => void;
}

function ConfirmationModal(props: ConfirmationModalProps) {
  console.log({ props });
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="flex justify-center"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {`Are you sure you want to delete `}
        <span className="text-red-500">{props.name}</span>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            // handleUserDelete(props.userId);
            props.onDelete(props.id);
            props.onHide();
          }}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;
